import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";

const API_ROOT = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");

function fmtDate(val) {
  if (!val) return "";
  const d = new Date(val);
  if (isNaN(d)) return String(val).slice(0, 10);
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yy = String(d.getFullYear()).slice(2);
  return `${dd}/${mm}/${yy}`;
}

export default function StudentLeave() {
  const localUser = useMemo(() => {
    try { return JSON.parse(localStorage.getItem("user") || "null"); }
    catch { return null; }
  }, []);

  const moduleId = parseInt(localUser?.moduleId, 10);
  const navigate = useNavigate();

  const [rows,    setRows]    = useState([]);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState("");

  useEffect(() => {
    if (moduleId !== 5) return;
    fetch(`${API_ROOT}/api/students/leave-list?moduleId=${moduleId}`)
      .then(r => r.json())
      .then(data => {
        if (!data.success) throw new Error(data.message || "Failed to load.");
        setRows(data.data || []);
      })
      .catch(err => setError(err.message || "Failed to load leave list."))
      .finally(() => setLoading(false));
  }, [moduleId]);

  if (moduleId !== 5) {
    return (
      <div className="container mt-4">
        <div className="alert alert-danger">Unauthorized access Or Session Timed out.</div>
      </div>
    );
  }

  return (
    <div className="container-fluid mt-3">
      <h3 className="ctitle">Leave Details</h3>

      <div className="mb-3 d-flex gap-2">
        <button className="btn btn-primary btn-sm" onClick={() => navigate("/student-leave-new")}>
          New Leave
        </button>
        <button className="btn btn-secondary btn-sm" onClick={() => navigate("/student-ind-leave")}>
          Individual Stu Leave
        </button>
      </div>

      {loading && <div className="text-center py-3">Loading...</div>}
      {error   && <div className="alert alert-danger">{error}</div>}

      {!loading && !error && rows.length === 0 && (
        <div className="alert alert-info">No leave records found.</div>
      )}

      {rows.length > 0 && (
        <div className="table-responsive">
          <table className="pending-verif-table table table-sm table-bordered" style={{ fontSize: "12px", whiteSpace: "nowrap" }}>
            <thead style={{ '--bs-table-bg': '#008080', color: 'white' }}>
              <tr>
                <th>SNo</th>
                <th>Name</th>
                <th>Leave Type</th>
                <th>From</th>
                <th>To Date</th>
                <th>Days</th>
                <th>Day</th>
                <th>Remarks</th>
                <th>Status</th>
                <th>Entry By</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td style={{ whiteSpace: "normal", minWidth: 130 }}>{r.StudentName}</td>
                  <td>{r.LeaveType}</td>
                  <td>{fmtDate(r.FromDate)}</td>
                  <td>{fmtDate(r.ToDate)}</td>
                  <td>{r.NoOfDays}</td>
                  <td>{r.HFDay}</td>
                  <td style={{ whiteSpace: "normal", minWidth: 120 }}>{r.Remarks}</td>
                  <td>{r.Status}</td>
                  <td>{r.EntryBy}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
